import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
const suggestions = [{
  label: 'Return home',
  to: '/'
}, {
  label: 'Search the website',
  to: '/search'
}, {
  label: 'Explore the agenda',
  to: '/agenda'
}];
export function NotFound() {
  return <section className="bg-sand-50 py-24 lg:py-32" aria-labelledby="notfound-heading" data-id="element-1212" data-mp="154pj08y4oq2r">
      <div className="mx-auto max-w-content px-4 sm:px-6 lg:px-10" data-id="element-1213" data-mp="1a42aj6zy2lbo">
        <p className="font-display text-[64px] leading-none text-gold-500" data-id="element-1214" data-mp="1a3sizez9463v">404</p>
        <h1 id="notfound-heading" className="mt-4 max-w-[18ch] font-display text-[32px] leading-tight text-ink sm:text-[42px]" data-id="element-1215" data-mp="1f1kiov650wim">
          This page could not be found.
        </h1>
        <p className="mt-4 max-w-xl text-[17px] leading-relaxed text-slate-600" data-id="element-1216" data-mp="1nunrur9r2n7g">
          The link may be out of date, or the page may have moved as the campaign publishes new
          material. Here is where most people go next.
        </p>
        <ul className="mt-8 flex flex-wrap gap-3" data-id="element-1217" data-mp="1nvlxnah994st">
          {suggestions.map((item, index) => <li key={item.to} data-id="element-1218" data-mp="1ix0wn8u6ih3b" data-mpi={index}>
              <Link to={item.to} className={`inline-flex h-12 items-center gap-2 rounded-lg px-6 text-[15px] font-semibold transition-colors duration-150 ease-emphasis ${index === 0 ? 'bg-green-600 text-white hover:bg-green-700' : 'border border-ink/20 text-ink hover:border-ink/40 hover:bg-ink/[0.04]'}`} data-id="element-1219" data-mp="1ivzhas64r8fs">
                {item.label}
                <ArrowRightIcon aria-hidden className="h-4 w-4" data-id="element-1220" data-mp="1xtruves49mrc" />
              </Link>
            </li>)}
        </ul>
      </div>
    </section>;
}